import React from 'react';

const Filter = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 18 12" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="Filter_a" d="M1014 111h4v-2h-4zm-4-5h12v-2h-12zm-3-5h18v-2h-18z" />
    </defs>
    <use fill="currentColor" xlinkHref="#Filter_a" transform="translate(-1007 -99)" />
  </svg>
);

export default Filter;



// WEBPACK FOOTER //
// ./src/common/icons/Filter.js